<div class="device-panel flex flex-row flex-wrap">
  <div class="lt-md:!hidden flex flex-row justify-center items-center flex-[5%] max-w-[5%]">
    <mat-icon class="online" *ngIf="device.connectionStatus === connectionStatus.connected"
      >check_circle</mat-icon
    >
    <mat-icon class="offline" *ngIf="isSrcDeviceNotConnected">wifi_off</mat-icon>
  </div>
  <div
    class="delete-icon-column flex gt-sm:flex-row justify-between items-center flex-[25%] max-w-[25%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <div class="flex flex-row justify-center items-center">
      <div data-at-comissioning-room-device-name-label class="name-column flex flex-col">
        <span data-at-all-devices-modal-device-type class="device-type">{{
          device.device.roles | translateDeviceByRoles | dash
        }}</span>
        <span data-at-all-devices-modal-device-id class="device-id">{{
          device.device.id | idPrefixRemover | dash | serialSpacing
        }}</span>
      </div>
      <mat-icon
        class="icon-wrapper warning gt-sm:!hidden"
        *ngIf="device.mountingMode"
        data-at-comissioning-device-mounting-mode-tooltip
        matTooltip="{{ '+COMMISSIONING.DEVICE_INDICATOR.MOUNTING_MODE_WARNING.TITLE' | translate }}"
        >error_outline</mat-icon
      >
    </div>
    <div class="gt-sm:!hidden flex flex-row justify-center items-center">
      <div *ngIf="canDeleteClimateSensor; else infoIcon">
        <button
          *ngIf="!(isFHTChannel$ | async)"
          mat-icon-button
          class="delete-btn"
          (click)="onDeleteDeviceAttempt(device.device)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <ng-template #infoIcon>
        <mat-icon
          class="icon-wrapper"
          data-at-comissioning-room-device-error-tooltip
          matTooltip="{{
            '+COMMISSIONING.DEVICE.TOOLTIP.INFO_DELETE_CLIMATE_SENSOR_FROM_ROOM' | translate
          }}"
          >error_outline</mat-icon
        >
      </ng-template>
    </div>
  </div>
  <div
    class="bordered lt-md:!flex lt-md:flex-row gt-sm:!hidden justify-between items-center flex-[15%] max-w-[15%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <span class="mobile-feature-title">{{
      '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.CONNECTION_STATUS' | translate
    }}</span>
    <mat-icon class="online" *ngIf="device.connectionStatus === connectionStatus.connected"
      >check_circle</mat-icon
    >
    <mat-icon class="offline" *ngIf="isSrcDeviceNotConnected">wifi_off</mat-icon>
  </div>
  <div
    class="feature-cell bordered lt-md:flex lt-md:flex-row lt-md:justify-between lt-md:items-center flex-[15%] max-w-[15%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <span class="mobile-feature-title gt-sm:!hidden"
      >{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.ROOM' | translate }}:</span
    >
    <span
      data-at-all-devices-modal-device-room
      class="feature-value"
      [matTooltip]="device.room ? device.room : null"
      >{{ device.room | dash }}</span
    >
  </div>
  <div
    class="feature-cell bordered lt-md:flex lt-md:flex-row lt-md:justify-between lt-md:items-center flex-[10%] max-w-[10%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <span class="mobile-feature-title gt-sm:!hidden"
      >{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.SIGNAL' | translate }}:</span
    >
    <!-- TODO commented by VIG-2626, VIG-2729 -->
    <!-- <span
      data-at-all-devices-modal-device-signal
      [class]="getClassBasedOnWifiStrength(device.signal)"
      >{{ device.signal | suffix: SUFFIX.decibelMilliWatt }}</span
    > -->
    <span data-at-all-devices-modal-device-signal>
      {{
        device.connectionStatus !== connectionStatus.connected
          ? noValue
          : (device.signal | suffix: SUFFIX.percentage)
      }}
    </span>
  </div>
  <div
    class="feature-cell battery-level-cell bordered lt-md:flex lt-md:flex-row lt-md:justify-between lt-md:items-center flex-[10%] max-w-[10%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <span class="mobile-feature-title gt-sm:!hidden"
      >{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.BATTERY' | translate }}:</span
    >
    <span
      class="battery-status"
      data-at-all-devices-modal-device-battery
      [class.low]="
        device.battery > criticalBatteryThreshold && device.battery < lowBatteryThreshold
      "
      [class.critical]="device.battery <= criticalBatteryThreshold"
    >
      {{
        device.connectionStatus !== connectionStatus.connected
          ? noValue
          : (device.battery | suffix: SUFFIX.percentage)
      }}
    </span>
  </div>
  <div
    class="feature-cell bordered lt-md:flex lt-md:flex-row lt-md:justify-between flex-[15%] max-w-[15%] lt-md:items-center lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <span class="mobile-feature-title gt-sm:!hidden"
      >{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.HEATING_CIRCUIT' | translate }}:</span
    >
    <ng-container *ngIf="heatingCircuitName$ | async as heatingCircuit">
      <span
        data-at-all-devices-modal-device-hc
        class="feature-value"
        [matTooltip]="device.heatingCircuit ? heatingCircuit : null"
        >{{
          device.connectionStatus !== connectionStatus.connected ? noValue : heatingCircuit
        }}</span
      >
    </ng-container>
  </div>
  <div
    class="feature-cell lt-md:flex lt-md:flex-row lt-md:justify-between lt-md:items-center flex-[10%] max-w-[10%] lt-md:flex-[100%] lt-md:max-w-[100%]"
  >
    <ng-container *ngIf="hasAnyFHTDemandRelayMode$ | async">
      <span class="mobile-feature-title gt-sm:!hidden">
        {{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.FHT_DEMAND_RELAY_MODE' | translate }}:
      </span>
      <span data-at-all-devices-modal-device-plug-157 class="feature-value">
        {{ device.fhtDemandRelayMode | translate }}
      </span>
    </ng-container>
  </div>
  <div
    class="delete-icon-column lt-md:!hidden flex flex-row justify-end items-center flex-[10%] max-w-[10%]"
  >
    <mat-icon
      class="icon-wrapper warning"
      *ngIf="device.mountingMode"
      data-at-comissioning-device-mounting-mode-tooltip
      matTooltip="{{ '+COMMISSIONING.DEVICE_INDICATOR.MOUNTING_MODE_WARNING.TITLE' | translate }}"
      >error_outline</mat-icon
    >
    <ng-container [ngSwitch]="specificDeviceRole">
      <ng-container *ngSwitchCase="DeviceRoles.ClimateSensor">
        <ng-container *ngIf="canDeleteClimateSensor; then deleteBtn; else infoIcon"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="DeviceRoles.Co2Sensor">
        <ng-container *ngIf="!isAnyFHTAssignedToRoom; then deleteBtn; else infoIcon"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="deleteBtn"></ng-container>
      </ng-container>
    </ng-container>
    <ng-template #deleteBtn>
      <button
        data-at-all-devices-modal-device-btn-delete
        data-at-comissioning-room-delete-device
        *ngIf="!(isFHTChannel$ | async)"
        mat-icon-button
        gtm="onOpen"
        gtmAction="Delete device confirmation panel"
        gtmCategory="allAddedDevices"
        class="delete-btn"
        (click)="onDeleteDeviceAttempt(device.device)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </ng-template>
    <ng-template #infoIcon>
      <mat-icon
        class="icon-wrapper"
        data-at-comissioning-room-device-error-tooltip
        matTooltip="{{
          '+COMMISSIONING.DEVICE.TOOLTIP.INFO_DELETE_CLIMATE_SENSOR_FROM_ROOM' | translate
        }}"
        >error_outline</mat-icon
      >
    </ng-template>
  </div>
  <!-- device alert message -->
  <div class="device-panel-alert">
    <app-banner *ngIf="isSrcDeviceNotConnected">
      {{ '+INSTALLATIONS.DEVICE_STATUS.DISCONNECTED' | translate }}
      {{
        device.connectionStatusTimestamp
          | dateForSpecificTimezone: (installationDetailsStore.installationTimezone$ | async)
          | date: 'short'
      }}
    </app-banner>

    <!-- device error message -->
    <ng-container *ngIf="deviceErrors$ | async as deviceErrors">
      <app-banner *ngFor="let error of deviceErrors">
        <b>{{ error?.errorCode }}</b> {{ error?.errorDescription }}
        {{ error?.appearedAt | date: 'short' }}
      </app-banner>
    </ng-container>
  </div>
</div>
